"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../Schema/utils");

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const KioskPageLinkField = props => {
  const formData = props.formData,
        formContext = props.formContext,
        schema = props.schema,
        uiSchema = props.uiSchema,
        registry = props.registry;
  const mediaId = formData && formData.mediaId;
  const media = formData && formData.media;
  const referenceId = formData && formData.referenceId;
  const reference = formData && formData.reference;
  const referenceTitle = reference && reference.title;
  const imageUrl = media.imageUrl || reference.imageUrl;
  const imageFocalpoint = formData && formData.imageFocalpoint;
  const imageCropdata = formData && formData.imageCropdata;
  const imageFilters = formData && formData.imageFilters;
  const backgroundColor = formData && formData.backgroundColor;
  const color = formData && formData.color;

  const getContrastColor = hex => {
    const color = (0, _color.default)(hex);
    return color.isLight() && "black" || "white";
  };

  const handleChange = formData => {
    if (formData.backgroundColor !== backgroundColor) {
      formData.color = getContrastColor(formData.backgroundColor);
    }

    if (formData.color !== color) {
      formData.titleColor = formData.color;
    }

    const newFormData = (0, _utils.getDefaultFormState)(schema, formData, registry.definitions);
    props.onChange && props.onChange(newFormData);
  };

  const handleMediaChange = ({
    mediaId,
    media
  }) => {
    const newFormData = (0, _utils.getDefaultFormState)(schema, _extends({}, formData, {
      mediaId: mediaId,
      media: media
    }), registry.definitions);
    props.onChange && props.onChange(newFormData);
  };

  const handleUpload = ({
    acceptedFiles = []
  }) => {
    formContext.onUpload && formContext.onUpload({
      formContext,
      schema,
      onChange: handleMediaChange
    }, acceptedFiles);
  };

  const handleMediaDialog = query => {
    formContext.onDialog && formContext.onDialog(_extends({}, props, {
      query: query,
      onChange: handleMediaChange
    }));
  };

  const handleReferenceChange = ({
    referenceId,
    reference
  }) => {
    const newFormData = (0, _utils.getDefaultFormState)(schema, _extends({}, formData, {
      referenceId: referenceId,
      reference: reference
    }), registry.definitions);
    props.onChange && props.onChange(newFormData);
  };

  const handleReferenceDialog = query => {
    formContext.onDialog && formContext.onDialog(_extends({}, props, {
      query: query,
      onChange: handleReferenceChange
    }));
  };

  const handleDialog = dialog => {
    handleReferenceDialog(dialog);
  };

  const handleCropdata = imageCropdata => {
    props.onChange && props.onChange(_extends({}, formData, {
      imageCropdata: imageCropdata
    }));
  };

  const handleFocalpoint = imageFocalpoint => {
    props.onChange && props.onChange(_extends({}, formData, {
      imageFocalpoint: imageFocalpoint
    }));
  };

  const handleFilters = imageFilters => {
    props.onChange && props.onChange(_extends({}, formData, {
      imageFilters: imageFilters
    }));
  };

  const getUiSchema = () => {
    const uiOptions = (0, _utils.getUiOptions)(uiSchema);
    let fieldset = [];
    const uiPreview = {
      "ui:mediaId": mediaId,
      "ui:media": mediaId,
      "ui:referenceId": referenceId,
      "ui:reference": reference,
      "ui:imageUrl": imageUrl,
      "ui:imageCropdata": imageCropdata,
      "ui:imageFilters": imageFilters,
      "ui:imageFocalpoint": imageFocalpoint,
      "ui:onUpload": handleUpload
    };
    let newUiSchema = {};

    if (uiSchema.link) {
      newUiSchema.link = _extends({}, uiSchema.link, {}, uiPreview, {
        "linkContent": _extends({}, uiSchema.link.linkContent, {
          "title": _extends({}, uiSchema.link.linkContent.title, {
            "ui:placeholder": referenceTitle
          })
        })
      });
      fieldset.push('link');
    }

    if (uiSchema.imageCropdata && imageUrl) {
      newUiSchema.imageCropdata = _extends({}, uiSchema.imageCropdata, {}, uiPreview, {
        "ui:onChange": cropdata => handleCropdata(cropdata)
      });
      fieldset.push('imageCropdata');
    }

    if (uiSchema.imageFocalpoint && imageUrl) {
      newUiSchema.imageFocalpoint = _extends({}, uiSchema.imageFocalpoint, {}, uiPreview, {
        "ui:onChange": focalpoint => handleFocalpoint(focalpoint)
      });
      fieldset.push('imageFocalpoint');
    }

    if (uiSchema.imageFilters && imageUrl) {
      newUiSchema.imageFilters = _extends({}, uiSchema.imageFilters, {}, uiPreview, {
        "ui:onChange": filters => handleFilters(filters)
      });
      fieldset.push('imageFilters');
    }

    if (formContext.pageType === "annotate") {
      newUiSchema.imageAnnotations = _extends({}, uiSchema.imageAnnotations, {}, uiPreview);
      fieldset.push('imageAnnotations');
    }

    return _extends({}, newUiSchema, {
      "ui:options": uiOptions,
      "ui:fieldset": fieldset,
      "color": {
        "ui:backgroundColor": formData && formData.backgroundColor
      },
      "link": _extends({}, newUiSchema.link, {
        "linkContent": _extends({}, newUiSchema.link.linkContent, {
          "titleColor": {
            "ui:backgroundColor": formData && formData.backgroundColor
          }
        })
      })
    });
  };

  const newRegistry = _extends({}, registry, {
    formContext: _extends({}, registry.formContext, {
      "onUpload": handleUpload,
      "onMediaDialog": handleMediaDialog,
      "onMediaChange": handleMediaChange,
      "onReferenceDialog": handleReferenceDialog,
      "onReferenceChange": handleReferenceChange
    })
  });

  const newUiSchema = getUiSchema();
  const ObjectField = registry.fields.ObjectField;
  return _react.default.createElement(ObjectField, _extends({}, props, {
    uiSchema: newUiSchema,
    registry: newRegistry,
    onChange: handleChange
  }));
};

var _default = KioskPageLinkField;
exports.default = _default;
module.exports = exports.default;